import { openBlock as n, createElementBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return n(), t("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
